import chatProperties from './chatProperties';

// WebSocket configurations
const websocketConfig = {
    // Base WebSocket URL
    baseUrl: chatProperties.websocketUrl || 'wss://ws.preprod-cx.ozonetel.com/chat',

    // Reconnection settings
    reconnection: {
        autoReconnect: false,
        maxRetries: 5,
        retryInterval: 3000, // 3 seconds
        backoffMultiplier: 1.5, // Increase wait time between retries
    },

    // Ping/pong settings to keep connection alive
    heartbeat: {
        enabled: true,
        interval: 30000, // 30 seconds
        payload: { type: 'ping' },
    },

    // Default event names
    events: {
        connect: 'connect',
        disconnect: 'disconnect',
        message: 'message',
        error: 'error',
        reconnect: 'reconnect',
        reconnectAttempt: 'reconnect_attempt',
        newMessage: 'new_message',
        closeSocket: 'closeAgentSubUserTab'
    }
};

export default websocketConfig; 